<template>
  <div>
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card class="pa-2">
        <v-card-text class="pb-0">
          <div class="d-flex align-center text-success mb-2">
            <v-icon start color="success">mdi-check-circle-outline</v-icon>
            {{ $t("acceptance.offer.vehicle_saved") }}
          </div>
          <div class="text-h6 mb-2">{{ $t("acceptance.offer.title") }}</div>
          <div class="text-body-2">
            {{
              $t("acceptance.offer.body", { vehicle: vehicleName, id: shortId })
            }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="outlined"
            color="primary"
            :disabled="loading"
            @click="close"
          >
            {{ $t("acceptance.offer.later") }}
          </v-btn>
          <v-btn
            variant="flat"
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="startNow"
          >
            {{ $t("acceptance.offer.start_now") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" color="error" location="top" :timeout="8000">
      {{ $t("acceptance.offer.start_failed") }}
    </v-snackbar>
  </div>
</template>

<script>
import { newCommandId, startDossier } from "@/api/compliance";

// Offered after "Aggiungi Veicolo" saves a car (Dismantling & Compliance, switch on only).
// The parent opens it with open(savedCar); a failure here never affects the saved car.
export default {
  name: "StartAcceptanceDialog",
  data: () => ({
    dialog: false,
    loading: false,
    snackbar: false,
    car: null,
    commandId: null,
  }),
  computed: {
    vehicleName() {
      if (!this.car) return "";
      const brand = this.car.brand && this.car.brand.title;
      const model = this.car.model && this.car.model.description;
      return [brand, model].filter(Boolean).join(" ");
    },
    shortId() {
      const id = this.car && this.car._id ? String(this.car._id) : "";
      return id.slice(-6);
    },
  },
  methods: {
    open(car) {
      this.car = car;
      // One command per offer: a retry of "Avvia ora" reuses it, so a double click starts one dossier.
      this.commandId = newCommandId();
      this.loading = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async startNow() {
      if (this.loading || !this.car) return;
      this.loading = true;
      try {
        const result = await startDossier(String(this.car._id), this.commandId);
        this.dialog = false;
        this.$router.push(`/acceptance/${result.dossier.id}`);
      } catch (err) {
        this.dialog = false;
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
